export default __webpack_public_path__ + "static/media/Taras295.f920f39c.jpg";